import styled from 'styled-components';
import { CONTAINER_COLORS, ICON_COLORS } from './colors';

export const Container = styled.div``;

export const Title = styled.span`
  color: #000;
  white-space: nowrap;
  font-family: 'Mangueira', sans-serif;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #bfbfbf;
  margin: 8px 0;
`;

type StatusProps = {
  status: string;
};

export const Content = styled.div<StatusProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: max-content;
`;

export const Status = styled.div<StatusProps>`
  background-color: ${({ status }) => ICON_COLORS[status]};
  width: 8px;
  height: 8px;
  border-radius: 50%;

  @media (max-width: 600px) {
    width: 12px;
    height: 12px;
    margin-bottom: 2px;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const LabelItem = styled.span`
  display: inline-flex;
  color: #007bff;
  font-weight: 900;
  font-size: 14px;
`;

export const ValueItem = styled.span`
  display: inline-flex;
  font-size: 14px;
`;

export const StatusWrap = styled.div``;
